import ReceiveManagement from './ReceiveManagement.vue'
export default ReceiveManagement



// WEBPACK FOOTER //
// ./src/pages/ReceiveManagement/index.js